'use client';
import Pagination from '@/components/pagination';
import PoliceLineDivider from '@/components/police-line-divider';
import { ListContainer } from '@/hooks/use-board';
import { STORY_LIST_LIMIT } from '@/lib/article-list';
import { ArticleType } from '@/services/types/article.type';
import ArticleCard from './components/article-card';
import ArticleHeader from './components/article-header';

// 운전면허 취득절차
export default function Client() {
  return (
    <ListContainer
      type={ArticleType.LICENSE_PROCESS}
      limit={STORY_LIST_LIMIT}
      render={({ items, page, totalPages, onPageChange, headerItem }) => {
        return (
          <>
            {headerItem && <ArticleHeader {...headerItem} />}
            <div className="desktop:my-20 my-14">
              <PoliceLineDivider />
            </div>
            <div className="divide-stroke-white flex flex-col gap-7 divide-y-1">
              {items.map((item) => (
                <div className="pb-6 last:pb-0" key={item.id}>
                  <ArticleCard {...item} />
                </div>
              ))}
            </div>
            <Pagination
              page={page}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </>
        );
      }}
    />
  );
}
